import React, { useEffect, useState, FormEventHandler, FormEvent } from 'react';
import { Row, Col, Input, Button, Modal, message as Message } from 'antd';
import i18n from 'i18next';
import { SettingsRouteProps } from './Settings';
import LikeIcon from '../../assets/images/png/like.png';
import { useSelector, useDispatch } from 'react-redux';
import { getUserState } from '../../store/user/selector';
import { FaLock } from 'react-icons/fa';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { changePassword } from '../../store/auth/actions';
import { setError, setLoading } from '../../store/app-globals/actions';
import { PasswordUpdatedContent } from '../auth/ForgotPassword';
import { useHistory } from 'react-router-dom';
import { logoutuser } from '../../store/user/actions';

export interface FormState {
  password: string;
  confirmPassword: string;
}

export const ChangePassword: React.FC<SettingsRouteProps> = ({
  setHeaderTitle,
}) => {
  const { user } = useSelector(getUserState);
  const { hasError, isLoading, message } = useSelector(getAppGlobalState);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();
  const [userpass, setUser] = useState<FormState>({
    password: '',
    confirmPassword: '',
  });

  const handleFieldChange = (field: keyof FormState): FormEventHandler => (
    e: FormEvent<HTMLInputElement>
  ): void => {
    setUser({ ...userpass, [field]: e.currentTarget.value });
  };

  const setHeader: React.EffectCallback = () => {
    if (setHeaderTitle) setHeaderTitle(i18n.t('CHANGE_PASSWORD'));
  };

  const handleChangePassword = () => {
    if (userpass.confirmPassword.length < 6) {
      Message.error(i18n.t('PASSWORD_CHARACTERS'));
      return;
    }
    dispatch(
      changePassword(user.email, userpass.password, userpass.confirmPassword)
    );
  };

  const validate = () => {
    setDisabled(userpass.password === '' || userpass.confirmPassword === '');
  };
  const loggingout = () => {
    dispatch(logoutuser());
    Message.info('Logged out');
    history.push('/');
    Modal.destroyAll();
  };

  const confirmationSentModal = React.useCallback(() => {
    const modal = Modal.info({
      icon: null,
      centered: true,
      className: 'modal-content-container modal-content-description',
      okButtonProps: { style: { display: 'none' } },
      content: (
        <PasswordUpdatedContent
          icon={LikeIcon}
          description={i18n.t('RESET_PASSWORD_SUCCESSFUL')}
          onClick={loggingout}
          onStay={() => {
            setTimeout(() => {
              modal.destroy();
              history.goBack();
            }, 500);
          }}
        />
      ),
    });
  }, [history]);
  useEffect(() => {
    if (hasError) {
      Message.error(i18n.t('PASSWORD_INVALID'));
      dispatch(setError(false, ''));
      dispatch(setLoading(false, ''));
      return;
    }
    if (!isLoading && message && !hasError) {
      dispatch(setLoading(false, ''));
      setUser({ password: '', confirmPassword: '' });
      confirmationSentModal();
    }
  }, [isLoading]);
  useEffect(setHeader, [setHeaderTitle]);
  useEffect(validate, [userpass]);
  return (
    <div className="change-password-container">
      <Row>
        <Col span={24} className="input-field-container">
          <Input.Password
            size="large"
            placeholder={i18n.t('CURRENT_PASSWORD')}
            className="input-field"
            prefix={<FaLock color="rgba(255,255,255,0.7)" />}
            value={userpass.password}
            onChange={handleFieldChange('password')}
          />
        </Col>
        <Col span={24} className="input-field-container">
          <Input.Password
            size="large"
            placeholder={i18n.t('NEW_PASSWORD')}
            className="input-field"
            prefix={<FaLock color="rgba(255,255,255,0.7)" />}
            value={userpass.confirmPassword}
            onChange={handleFieldChange('confirmPassword')}
          />
        </Col>
      </Row>
      <Col span={24} className="login-button-container padded-bottom">
        <Button
          type="primary"
          shape="round"
          className="changepassword-button"
          disabled={disabled}
          onClick={handleChangePassword}
          loading={isLoading}
        >
          {i18n.t('CHANGE_PASSWORD')}
        </Button>
      </Col>
    </div>
  );
};
